import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module

import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { formatNumber, parseDate } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type ClientPortfolio = {
  id: number;
  strategy_from_id?: number;
  strategy_from_name?: string;
  strategy_to_id?: number;
  strategy_to_name?: string;
  closing_date?: string;
  weight?: number;
  market_value?: number;
  created_at: string;
};

// Definition of the columns

export const client_portfolios_columns: ColumnDef<ClientPortfolio>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "strategy_from_id",
    header: "Strategy From",
    cell: ({ row }) => {
      const value = row.getValue("strategy_from_id");
      if (!value) return null;
      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/qtl - referential/strategies/${value}`)}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {value}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "strategy_from_name",
    header: "Strategy From Name",
    cell: ({ row }) => {
      const id = row.original.strategy_from_id;
      const name = row.getValue("strategy_from_name");
      if (!id || !name) return null;
      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/qtl - referential/strategies/${id}`)}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {name}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "strategy_to_id",
    header: "Strategy To",
    cell: ({ row }) => {
      const value = row.getValue("strategy_to_id");
      if (!value) return null;
      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/qtl - referential/strategies/${value}`)}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {value}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "strategy_to_name",
    header: "Strategy To Name",
    cell: ({ row }) => {
      const id = row.original.strategy_to_id;
      const name = row.getValue("strategy_to_name");
      if (!id || !name) return null;
      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/qtl - referential/strategies/${id}`)}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {name}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "closing_date",
    header: "Closing Date",
    cell: ({ row }) => {
      return parseDate(row.getValue("closing_date"));
    },
  },
  {
    accessorKey: "weight",
    header: () => <div className="text-right">Weight</div>,
    cell: ({ row }) => {
      const value = row.getValue("weight") as number;
      if (value === null || value === undefined || Number.isNaN(value))
        return "";
      return <div className="text-right">{formatNumber(value, 3, 3)}</div>;
    },
  },
  {
    accessorKey: "market_value",
    header: () => <div className="text-right">Market Value</div>,
    cell: ({ row }) => {
      const value = row.getValue("market_value") as number;
      if (value === null || value === undefined || Number.isNaN(value))
        return "";
      return <div className="text-right">{formatNumber(value)}</div>;
    },
  },

  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => {
      return parseDate(row.getValue("created_at"));
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
